export default __webpack_public_path__ + "static/referral-banner-mobile-5669a044bd4accfd8a0e9ab8539dc79f.png";